var map = {
	"./bandle city_emblem.png": 3728,
	"./bandlecity.png": 7645,
	"./bilgewater.png": 6383,
	"./bilgewater_emblem.png": 7280,
	"./demacia.png": 1707,
	"./demacia_emblem.png": 694,
	"./freljord.png": 1430,
	"./freljord_emblem.png": 7279,
	"./ionia.png": 205,
	"./ionia_emblem.png": 6130,
	"./ixtal.png": 9086,
	"./ixtal_emblem.png": 1841,
	"./noxus.png": 8817,
	"./noxus_emblem.png": 6350,
	"./piltover.png": 6459,
	"./piltover_emblem.png": 6168,
	"./runeterra.png": 1111,
	"./runeterra_emblem.png": 6115,
	"./shadow isles_emblem.png": 5807,
	"./shadowisles.png": 1669,
	"./shurima.png": 385,
	"./shurima_emblem.png": 4241,
	"./shuriman.png": 8871,
	"./targon.png": 4491,
	"./targon_emblem.png": 852,
	"./the void_emblem.png": 7001,
	"./thevoid.png": 9375,
	"./zaun.png": 857,
	"./zaun_emblem.png": 9886
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4877;